var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataRecordLinesTable',{attrs:{"dataRecordLinesWithElementDetails":_vm.dataRecordLinesWithElementDetails,"description":"liveFeed","endTime":_vm.endTime}})
}
var staticRenderFns = []

export { render, staticRenderFns }